import React from 'react';
import PropTypes from 'prop-types';
import { Item, Picker } from '@adobe/react-spectrum';
import { withTheme } from '../ThemeProvider';

const PickerDropdown = ({ ...props }) => {
  return (
    <Picker aria-label={props.placeholder} {...props}>
      {(item) => <Item key={item.value}>{item.label}</Item>}
    </Picker>
  );
};

PickerDropdown.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string,
    }),
  ).isRequired,
  width: PropTypes.string,
  placeholder: PropTypes.string,
  onSelectionChange: PropTypes.func,
};

PickerDropdown.defaultProps = {
  placeholder: '',
  width: undefined,
  onSelectionChange: () => {},
};

PickerDropdown.displayName = 'PickerDropdown';

export default withTheme(PickerDropdown);
